import useSchedulesManager from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useSchedulesManager.ts";
import useDomainSiteOnRoute from "@/shared/routing/useDomainSiteOnRoute.ts";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { useReactToPrint, type UseReactToPrintFn } from "react-to-print";
import { DateStyle } from "@/shared/utils/Dates.ts";
import { PrintScheduleTimeSlotsContentRefContext } from "@/pages/human-resources/time-management/schedules/site-schedule/day-view/model/printing/PrintScheduleTimeSlotsContentRefProvider.tsx";

export default function usePrintScheduleTimeSlots(reactToPrintParams: {
  onAfterPrint: () => void;
  onPrintError: () => void;
}): UseReactToPrintFn {
  const {
    contractsManager: { startDate: date },
  } = useSchedulesManager();
  const { site } = useDomainSiteOnRoute();
  const { t } = useTranslation(["humanResources"]);
  const printableContentRef = useContext(
    PrintScheduleTimeSlotsContentRefContext,
  );
  return useReactToPrint({
    bodyClass: "body medium",
    contentRef: printableContentRef,
    documentTitle: t("timeManagement.print.dailySchedule.docTitle", {
      siteName: site?.name,
      date: date,
      formatParams: {
        date: { style: DateStyle.WEEKDAY_SHORT_DATE_MONTH_SHORT },
      },
    }),
    ...reactToPrintParams,
  });
}
